<template>
  <div>
    <a-result status="404" title="抱歉，您访问的页面不存在">
      <template v-slot:extra>
        <a-button type="primary" @click="$router.push({path:'/'})">返回首页</a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {}
</script>

